(() => {
  'use strict';

  const validHandles = {
    pages: new Set([
      'about-us',
      'contact',
      'faq',
      'gift-guide',
      'jewellery-care-guide',
      'payment-options',
      'return-refund-policy',
      'shipping-delivery',
      'size-guide',
      'track-order',
    ]),
    collections: new Set([
      'all',
      'anklets',
      'best-sellers',
      'bracelets',
      'earrings',
      'gifts-under-aed-100',
      'jewellery-sets',
      'necklaces',
      'new-arrivals',
      'rings',
    ]),
    policies: new Set([
      'privacy-policy',
      'refund-policy',
      'shipping-policy',
      'terms-of-service',
    ]),
  };

  const legacyCollectionAliases = new Map([
    ['all-products', 'all'],
    ['new-collection', 'all'],
  ]);

  function repairedPath(pathname) {
    const malformedJournal = pathname.match(/^\/(ar\/)?blogsnews\/?$/i);
    if (malformedJournal) {
      const locale = malformedJournal[1] || '';
      return `/${locale}blogs/news`;
    }

    const legacyJournal = pathname.match(/^\/(ar\/)?blogs\/catwalk-journal\/?$/i);
    if (legacyJournal) {
      const locale = legacyJournal[1] || '';
      return `/${locale}blogs/news`;
    }

    const normalResource = pathname.match(/^\/(ar\/)?(pages|collections|policies)\/([a-z0-9][a-z0-9-]*)\/?$/i);
    if (normalResource) {
      const locale = normalResource[1] || '';
      const resource = normalResource[2].toLowerCase();
      let handle = normalResource[3].toLowerCase();

      if (resource === 'collections' && legacyCollectionAliases.has(handle)) {
        handle = legacyCollectionAliases.get(handle);
      }
      if (!validHandles[resource]?.has(handle)) return pathname;
      return `/${locale}${resource}/${handle}`;
    }

    const missingSlash = pathname.match(/^\/(ar\/)?(pages|collections|policies)([a-z0-9][a-z0-9-]*)\/?$/i);
    if (!missingSlash) return pathname;

    const locale = missingSlash[1] || '';
    const resource = missingSlash[2].toLowerCase();
    let handle = missingSlash[3].toLowerCase();

    if (resource === 'collections' && legacyCollectionAliases.has(handle)) {
      handle = legacyCollectionAliases.get(handle);
    }
    if (!validHandles[resource]?.has(handle)) return pathname;

    return `/${locale}${resource}/${handle}`;
  }

  function repairAnchor(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.href) return;

    const url = new URL(anchor.href, window.location.origin);
    if (url.origin !== window.location.origin) return;

    const corrected = repairedPath(url.pathname);
    if (corrected !== url.pathname) {
      url.pathname = corrected;
      anchor.href = `${url.pathname}${url.search}${url.hash}`;
    }
  }

  const currentPath = repairedPath(window.location.pathname);
  if (currentPath !== window.location.pathname) {
    window.location.replace(`${currentPath}${window.location.search}${window.location.hash}`);
    return;
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href]').forEach(repairAnchor);
  }, { once: true });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('a[href]') : null;
    repairAnchor(target);
  }, true);
})();
